module.exports = __webpack_public_path__ + "media/images/vp/samples/10-3734f64d84abb8b9aba13f633e6e997b.jpg";